var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureLicensesSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 2.667,
    x: 6.667,
    y: 0.333,
    rx: 0.333
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 2.667,
    x: 13,
    y: 13,
    rx: 0.333
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 2.667,
    x: 0.333,
    y: 13,
    rx: 0.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.192 3L13.611 13M2.389 13L7.808 3M13 14.333L3 14.333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureLicensesSmall);
export default __webpack_public_path__ + "static/media/azure-licenses-small.44d83ffdfd04b734251e6105d9bdf8f2.svg";
export { ForwardRef as ReactComponent };